import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full justify-between" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "bg-white p-4 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_5 = { class: "text-2xl font-bold text-gray-800" }
const _hoisted_6 = { class: "bg-white p-4 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_7 = { class: "text-2xl font-bold text-gray-800" }
const _hoisted_8 = { class: "bg-white p-4 rounded-lg shadow-sm border border-gray-200" }

import { computed } from "vue";
import { useRouter } from "vue-router";
import { useWeight } from "@/composables/tasks/vaccination/useVaccinationWeight";

import WeightRecordsTable from "@/components/v2/Tasks/Vaccination/Tables/WeightRecordsTable.vue";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WeightsView',
  setup(__props) {

const router = useRouter();
const goBack = () => router.go(-1);

const { weightRecords } = useWeight();

const totalRecords = computed(() => weightRecords.value.length);

const averageWeight = computed(() => {
  if (!weightRecords.value.length) return 0;
  const sum = weightRecords.value.reduce((acc, record) => acc + record.weight, 0);
  return Math.round((sum / weightRecords.value.length) * 100) / 100;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "flex justify-between items-center" }, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-800" }, "Weight Records", -1)),
        _createElementVNode("button", {
          onClick: goBack,
          class: "text-gray-600 hover:text-gray-800 flex items-center gap-1 text-sm"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M19 12H5M12 19l-7-7 7-7" })
          ], -1),
          _createTextVNode(" Back ")
        ]))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "w-full bg-secondary h-[1px] block" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-500 mb-1" }, "Total Records", -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(totalRecords.value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-sm font-medium text-gray-500 mb-1" }, "Average Weight", -1)),
          _createElementVNode("p", _hoisted_7, _toDisplayString(averageWeight.value) + "g", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-800 mb-4" }, "Weight Measurement History", -1)),
        _createVNode(WeightRecordsTable, { records: _unref(weightRecords) }, null, 8, ["records"])
      ])
    ]),
    _createVNode(FooterActions, null, {
      middle: _withCtx(() => [
        _createElementVNode("button", {
          onClick: goBack,
          class: "w-full"
        }, " Back ")
      ]),
      _: 1
    })
  ]))
}
}

})